import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const cls = "q-input min-h-[44px] w-full";
export const usd = (n) => (n == null ? "-" : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const fieldOf = (e) => { const d = e?.response?.data?.detail; return d && typeof d === "object" && d.field ? d : null; };
export const msgOf = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : d?.message || errMsg(e); };

export function In({ label, k, f, set, err, type = "text", ...rest }) {
  return (
    <label className="block min-w-0 text-xs font-semibold text-q-muted">{label}
      <input type={type} className={`${cls} mt-1 ${err?.field === k ? "border-red-400" : ""}`} value={f[k] ?? ""} onChange={(e) => set({ ...f, [k]: e.target.value })} data-testid={`f-${k}`} {...rest} />
      {err?.field === k && <span className="mt-1 block text-xs text-red-300" data-testid={`err-${k}`}>{err.message}</span>}
    </label>
  );
}

// PUT/POST with per-field validation errors shown next to the field.
export function useSave(fn, onDone) {
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async (...a) => {
    setBusy(true); setErr(null);
    try { const r = await fn(...a); onDone?.(r.data); toast.success("Saved"); } catch (e) { const fe = fieldOf(e); if (fe) setErr(fe); else toast.error(msgOf(e)); }
    setBusy(false);
  };
  return { err, busy, go };
}

export async function download(url, name) {
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    const u = URL.createObjectURL(data); const a = document.createElement("a"); a.href = u; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(u), 60000);
  } catch (e) { toast.error(errMsg(e)); }
}

export function AuthImg({ url, alt, className, testid }) {
  const [src, setSrc] = useState(null);
  if (!src) api.get(url, { responseType: "blob" }).then(({ data }) => setSrc(URL.createObjectURL(data))).catch(() => setSrc(""));
  return src ? <img src={src} alt={alt} className={className} data-testid={testid} /> : <div className={`${className} animate-pulse bg-q-raised`} />;
}

export const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "Unknown");
